import axios, { AxiosError } from "axios"
const API_URL = process.env.REACT_APP_API_URL

const promoCodeService = {
  // Vérifier si un code promo est valide (sans l'appliquer)
  async verifyPromoCode({ userId, code }: { userId: string, code: string }) {
    try {
      const token = localStorage.getItem("token")
      const res = await axios.post(
        `${API_URL}/promo-code/verify`,
        { userId, code },
        { headers: { Authorization: `Bearer ${token}` } }
      )
      return res.data
    } catch (error: AxiosError | any) {
      return { 
        valid: false, 
        message: error.response?.data?.message || "Erreur serveur lors de la vérification du code promo." 
      }
    }
  },

  // Appliquer le code promo lors de la création d'annonce
  async applyPromoCodeForAnnouncement({ 
    userId, 
    code, 
    announcementId 
  }: { 
    userId: string, 
    code: string, 
    announcementId: string 
  }) {
    try {
      const token = localStorage.getItem("token")
      const res = await axios.post(
        `${API_URL}/promo-code/apply-for-announcement`,
        { userId, code, announcementId },
        { headers: { Authorization: `Bearer ${token}` } }
      )
      return res.data
    } catch (error: AxiosError | any) {
      return { 
        applied: false, 
        message: error.response?.data?.message || "Erreur serveur lors de l'application du code promo." 
      }
    }
  }
}

export default promoCodeService